import { buildApiUrl, resolveApiBase } from './apiBase';
import { createApiHttpClient } from './httpClient';

export const USERS_API_BASE = resolveApiBase(import.meta.env.VITE_USERS_API_URL);

export const buildUsersUrl = (path: string) => buildApiUrl(USERS_API_BASE, path);

export const usersHttp = createApiHttpClient();
